(() => {
  const path = (window.location.pathname || '').toLowerCase();
  const isAdmin =
    path.includes('/pages/admin') ||
    path.includes('/pages/tava-admin') ||
    /\/admin\/?$/.test(path);

  if (!isAdmin) return;

  document.documentElement.setAttribute('data-tava-admin', 'true');
  document.title = 'TAVA Admin';

  document.querySelectorAll(
    '.header-wrapper, .section-header, .shopify-section-group-header-group, .shopify-section-group-footer-group, .tava-language-bar, .tava-lang-fixed, .announcement-bar, footer, .section-tava-language-bar, .template-404'
  ).forEach((el) => {
    el.style.display = 'none';
  });

  const main = document.getElementById('MainContent');
  if (main) {
    main.style.margin = '0';
    main.style.padding = '0';
    main.style.background = '#faf8f4';
    main.style.minHeight = '100vh';
  }
  document.body.style.background = '#faf8f4';

  let root = document.getElementById('root');
  if (!root) {
    root = document.createElement('div');
    root.id = 'root';
    (main || document.body).prepend(root);
  }

  if (document.querySelector('script[data-tava-admin-js]')) return;

  const configured = window.TAVA_ADMIN_ASSETS || {};
  const boot = document.querySelector('script[src*="tava-admin-boot.js"]');
  const fromBoot = (name) => {
    if (!boot?.src) return '';
    return boot.src.replace(/tava-admin-boot\.js.*$/, name);
  };

  const cssHref = fromBoot('tava-admin-app.css') || configured.css;
  const jsHref = fromBoot('tava-admin-app.js') || configured.js;

  if (cssHref && !document.querySelector('link[data-tava-admin-css]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssHref;
    link.setAttribute('data-tava-admin-css', 'true');
    document.head.appendChild(link);
  }

  if (jsHref) {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = jsHref;
    script.setAttribute('data-tava-admin-js', 'true');
    script.onerror = () => {
      root.innerHTML =
        '<div class="auth-screen"><div class="auth-card"><h1>TAVA Admin</h1><p>Could not load the admin app. Refresh this preview page.</p></div></div>';
    };
    document.body.appendChild(script);
  }
})();
